import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {TagsComponent} from "@webmate-web-core/shared/components/tags/tags.component";
import {PopoverModule} from "primeng/popover";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {InputTextModule} from "primeng/inputtext";
import {TooltipModule} from "primeng/tooltip";
import {ButtonModule} from "primeng/button";
import { FormsModule } from '@angular/forms';
import {AutoFocusModule} from "primeng/autofocus";

@NgModule({
    declarations: [
        TagsComponent
    ],
    imports: [CommonModule, PopoverModule, FontAwesomeModule, InputTextModule, TooltipModule, ButtonModule, FormsModule, AutoFocusModule],
    exports: [
        TagsComponent
    ]
})
export class TagsModule { }
